export default __webpack_public_path__ + "static/media/meeting_logo.a4f839ad.png";